(function (cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [
    {
      name: 'quicktest_atlas_1',
      frames: [
        [0, 0, 820, 884],
        [822, 0, 820, 884],
        [1644, 0, 59, 87],
      ],
    },
    {
      name: 'quicktest_atlas_2',
      frames: [
        [0, 0, 820, 884],
        [0, 886, 820, 884],
        [822, 0, 820, 884],
        [822, 886, 820, 884],
      ],
    },
  ];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:

  (lib.quickimage_01 = function () {
    this.initialize(ss['quicktest_atlas_2']);
    this.gotoAndStop(0);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_02 = function () {
    this.initialize(ss['quicktest_atlas_2']);
    this.gotoAndStop(1);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_03 = function () {
    this.initialize(ss['quicktest_atlas_2']);
    this.gotoAndStop(2);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_04 = function () {
    this.initialize(ss['quicktest_atlas_2']);
    this.gotoAndStop(3);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_05 = function () {
    this.initialize(ss['quicktest_atlas_1']);
    this.gotoAndStop(0);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_06 = function () {
    this.initialize(ss['quicktest_atlas_1']);
    this.gotoAndStop(1);
  }).prototype = p = new cjs.Sprite();

  (lib.quickimage_07 = function () {
    this.initialize(ss['quicktest_atlas_1']);
    this.gotoAndStop(2);
  }).prototype = p = new cjs.Sprite();

  (lib.onlever = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quickimage_07();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 59, 87);

  // stage content:
  (lib.quickstart = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_7
    this.instance = new lib.onlever('synched', 0);
    this.instance.setTransform(132.5, 549.5, 1, 1, 0, 0, 0, 29.5, 43.5);

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(152)
        .to({ startPosition: 0 }, 0)
        .wait(1)
        .to({ y: 549.35 }, 0)
        .wait(1)
        .to({ y: 549.05 }, 0)
        .wait(1)
        .to({ y: 548.55 }, 0)
        .wait(1)
        .to({ y: 547.85 }, 0)
        .wait(1)
        .to({ y: 546.95 }, 0)
        .wait(1)
        .to({ y: 545.85 }, 0)
        .wait(1)
        .to({ y: 544.55 }, 0)
        .wait(1)
        .to({ y: 543.05 }, 0)
        .wait(1)
        .to({ y: 541.35 }, 0)
        .to({ y: 520.5 }, 8, cjs.Ease.quadOut)
        .wait(26)
    );

    // Layer_6
    this.instance_1 = new lib.quickimage_06();
    this.instance_1.setTransform(0, 1);
    this.instance_1._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_1).wait(149).to({ _off: false }, 0).wait(46)
    );

    // Layer_5
    this.instance_2 = new lib.quickimage_05();
    this.instance_2.setTransform(0, 1);
    this.instance_2._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_2)
        .wait(114)
        .to({ _off: false }, 0)
        .to({ _off: true }, 25)
        .wait(56)
    );

    // Layer_4
    this.instance_3 = new lib.quickimage_04();
    this.instance_3.setTransform(0, 1);
    this.instance_3._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_3)
        .wait(79)
        .to({ _off: false }, 0)
        .to({ _off: true }, 25)
        .wait(91)
    );

    // Layer_3
    this.instance_4 = new lib.quickimage_03();
    this.instance_4.setTransform(0, 1);
    this.instance_4._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_4)
        .wait(44)
        .to({ _off: false }, 0)
        .to({ _off: true }, 25)
        .wait(126)
    );

    // Layer_2
    this.instance_5 = new lib.quickimage_02();
    this.instance_5.setTransform(0, 1);
    this.instance_5._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_5)
        .wait(9)
        .to({ _off: false }, 0)
        .to({ _off: true }, 25)
        .wait(161)
    );

    // Layer_1
    this.instance_6 = new lib.quickimage_01();
    this.instance_6.setTransform(0, 1);

    this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(195));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(410, 443, 410, 442);
  // library properties:

  if (window.innerWidth < 1024) {
    lib.properties = {
      id: '18894AA6AC599A4481DFF3CBA31F7C23',
      width: 410,
      height: 322,
      fps: 20,
      color: '#FFFFFF',
      opacity: 1.0,
      manifest: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0609/3658/5381/files/quicktest_atlas_1_6eaf3e0e-3a2e-4bba-ab25-191873b6cfec.png?v=1699363582',
          id: 'quicktest_atlas_1',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0609/3658/5381/files/quicktest_atlas_2_ca3f1a9d-30ec-4120-930e-18f34c7be3ce.png?v=1699363582',
          id: 'quicktest_atlas_2',
        },
      ],
      preloads: [],
    };
  } else {
    lib.properties = {
      id: '18894AA6AC599A4481DFF3CBA31F7C23',
      width: 820,
      height: 884,
      fps: 20,
      color: '#FFFFFF',
      opacity: 1.0,
      manifest: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0609/3658/5381/files/quicktest_atlas_1_6eaf3e0e-3a2e-4bba-ab25-191873b6cfec.png?v=1699363582',
          id: 'quicktest_atlas_1',
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0609/3658/5381/files/quicktest_atlas_2_ca3f1a9d-30ec-4120-930e-18f34c7be3ce.png?v=1699363582',
          id: 'quicktest_atlas_2',
        },
      ],
      preloads: [],
    };
  }

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['18894AA6AC599A4481DFF3CBA31F7C23'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers
  ) {
    var lastW,
      lastH,
      lastS = 1;
    // window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;

      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h
              );
            }
          }
        }
      }
    }
  };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));
var createjs, AdobeAn;
